import React, { useEffect, useState } from "react";
import client, { apiError } from "@/api/client";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Plus, Pencil } from "lucide-react";

export default function Suppliers() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", address: "" });
  const [editId, setEditId] = useState(null);

  const load = () => client.get("/suppliers").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editId) await client.put(`/suppliers/${editId}`, form);
      else await client.post("/suppliers", form);
      toast.success("Supplier disimpan"); setOpen(false); load();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="p-6 space-y-5 animate-in-up">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Supplier</h1>
          <p className="text-sm text-muted-foreground">Daftar pemasok barang</p>
        </div>
        <Button onClick={() => { setForm({ name: "", phone: "", address: "" }); setEditId(null); setOpen(true); }} data-testid="add-supplier-btn"><Plus className="mr-2 h-4 w-4" /> Tambah</Button>
      </div>
      <div className="rounded-lg border bg-white">
        <Table>
          <TableHeader><TableRow><TableHead>Nama</TableHead><TableHead>Telepon</TableHead><TableHead>Alamat</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((s) => (
              <TableRow key={s.id} className="hover:bg-slate-50">
                <TableCell className="font-medium">{s.name}</TableCell>
                <TableCell>{s.phone || "-"}</TableCell>
                <TableCell>{s.address || "-"}</TableCell>
                <TableCell><Button size="icon" variant="ghost" onClick={() => { setForm({ name: s.name, phone: s.phone || "", address: s.address || "" }); setEditId(s.id); setOpen(true); }}><Pencil className="h-4 w-4" /></Button></TableCell>
              </TableRow>
            ))}
            {!items.length && <TableRow><TableCell colSpan={4} className="py-8 text-center text-muted-foreground">Belum ada supplier</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-sm">
          <DialogHeader><DialogTitle>{editId ? "Ubah" : "Tambah"} Supplier</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div className="space-y-2"><Label>Nama</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="supplier-name" /></div>
            <div className="space-y-2"><Label>Telepon</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
            <div className="space-y-2"><Label>Alamat</Label><Input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Batal</Button><Button onClick={save} data-testid="save-supplier-btn">Simpan</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
